import { makeStyles } from "@mui/styles";
import { InfiniteScroll } from "components";
import { useAccountList, useContactList } from "hooks";
import { useEffect, useState } from "react";
import { groupDataByLetter } from "./helper";
import { useSelector } from "react-redux";
import { BranchSelectors } from "redux-store";
import { SystemConstant } from "const";
import DataListByLetter from "pages/HomePage/components/AddingContact/DataListByLetter";

const ContactListTab = ({ keyword, onClick }) => {
  const classes = useStyles();
  const {
    accountList,
    queryPagination: { page: queryPage, totalPage },
    getAccountList,
  } = useAccountList();
  const { contactList, isEnd: isEndContactList, getAllContactByName } = useContactList();

  const selectedBranch = useSelector(BranchSelectors.getSelectedBranch);
  const isBranchServer = selectedBranch.type === SystemConstant.SERVER_TYPE.branch;

  const [displayListByLetter, setDisplayListByLetter] = useState({}); // { <letter>: [] }

  const handleLoadMore = () => {
    if (isBranchServer && keyword && queryPage <= totalPage) {
      getAccountList({ keyword, page: queryPage + 1 });
    } else if (!isEndContactList) {
      getAllContactByName(keyword);
    }
  };

  useEffect(() => {
    if (isBranchServer && keyword) {
      getAccountList({ keyword, page: 1 });
    } else {
      getAllContactByName(keyword);
    }
  }, [keyword, selectedBranch]);

  useEffect(() => {
    if (isBranchServer && keyword) {
      setDisplayListByLetter(groupDataByLetter(accountList, "name"));
    } else {
      setDisplayListByLetter(groupDataByLetter(contactList, "name"));
    }
  }, [accountList, contactList]);

  return (
    <InfiniteScroll className={classes.contactListBox} onScrollToBottom={handleLoadMore}>
      {Object.keys(displayListByLetter)
        .sort()
        .map((firstLetter, index) => (
          <DataListByLetter
            key={index}
            dataList={displayListByLetter[firstLetter]}
            letter={firstLetter}
            onItemClick={onClick}
          />
        ))}
    </InfiniteScroll>
  );
};

export default ContactListTab;

const useStyles = makeStyles({
  contactListBox: {
    maxHeight: "calc(100vh - 330px)",
    overflow: "auto",
    padding: "16px 14px",
  },
});
